const isLocalBrowser = () =>
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1", "::1"].includes(window.location.hostname)

const getFunctionEndpoint = (functionName) =>
  `${isLocalBrowser() ? "/api" : "/.netlify/functions"}/${functionName}`

export default getFunctionEndpoint
